import { Injectable } from '@angular/core';
import { BaseApiService, SessionStorageService } from '@shared/data-access';
import { NotificationService } from '@shared/feature/notification-handling';
import { DownloadEvidenceRequest } from '../models/request.models';
import { switchMap } from 'rxjs';
import { TranslationFromJsonService } from '@shared/feature/translate';

@Injectable({
  providedIn: 'root',
})
export class DownloadEvidenceService {
  constructor(
    private api: BaseApiService,
    private notification: NotificationService,
    private sessionStorageService: SessionStorageService,
    private translationService: TranslationFromJsonService
  ) {}

  downloadEvidence(id: string): void {
    this.api.download(`api/files/${id}/download`).subscribe({
      next: () => this.notification.addSuccess(this.translationService.instant('successfully-performed-operation')),
    });
  }

  downloadEvidenceWithReasonHeader(id: string, request: DownloadEvidenceRequest): void {
    this.api
      .postWithHeaderAppend<string>(`api/files/${id}/download`, request, 'Filecodedownload', this.sessionStorageService.getItem('fileCode') ?? '')
      .pipe(switchMap((res) => this.api.downloadExternalURL(res)))
      .subscribe({
        complete: () => {
          this.notification.addSuccess(this.translationService.instant('successfully-performed-operation'));
        },
      });
  }
}
